import React from 'react'
import styled, { CSSProperties } from 'styled-components'
import { IToastProps } from '../../models/interfaces'
import { TDataTest } from '../../models/types'
import {
  IconToastSuccess,
  SVGContainer,
  Text,
  Container,
  EllipsisContainer,
  Action,
} from '../Global'
import { ToastCard } from '.'
import I18NText from '../I18NText'

export const ToastText = styled(Text)`
  ${Action({
    cursor: 'pointer',
    hoverAction: {
      opacity: 0.5,
    },
  })}
`

export function SuccessToast({
  delay = 5000,
  autohide = true,
  onClose = () => {},
  position = 'top-center',
  dataTestId,
  display,
  show,
  translationKey = 'toast.message.default.success',
  translationValues = undefined,
  onClick,
}: IToastProps & TDataTest & Pick<CSSProperties, 'display'>) {
  return (
    <>
      <ToastCard
        delay={delay}
        autohide={autohide}
        onClose={onClose}
        position={position}
        dataTestId={dataTestId}
        display={display}
        border={{
          style: 'solid',
          width: '1px',
          color: 'var(--toast-color-success)',
          radius: 'var(--gutter-5x)',
        }}
        height="var(--gutter-7x)"
        padding="var(--gutter-1x)"
        maxWidth="100%"
        width="auto"
        show={show}
      >
        <Container display="flex">
          <SVGContainer
            backgroundColor="var(--toast-color-success)"
            marginRight="var(--gutter-2x)"
            border={{ radius: 'var(--gutter-5x)' }}
            width="var(--gutter-5x)"
            height="var(--gutter-5x)"
            padding="var(--gutter-1x)"
            textAlign="center"
            preset="formfield-lg"
          >
            <IconToastSuccess />
          </SVGContainer>
          <EllipsisContainer padding="var(--gutter-1x) 0" display="flex">
            <Container
              marginRight="var(--gutter-5x)"
              data-testid="success-toast-message-container"
            >
              <I18NText
                id={translationKey}
                preset="paragraph regular"
                color="var(--font-color-dark)"
                values={translationValues}
              />
            </Container>
            {onClick && (
              <Container margin="0 var(--gutter-5x)">
                <ToastText
                  color="var(--toast-color-success)"
                  onClick={onClick}
                  preset="cta-sm"
                >
                  <I18NText id="try.again" />
                </ToastText>
              </Container>
            )}
          </EllipsisContainer>
        </Container>
      </ToastCard>
      <></>
    </>
  )
}
